
/*----------------------------------slick slider----------------------------------*/
if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === "function" && jQuery(".shophomecarousel ul.products").length) {
  jQuery('.shophomecarousel ul.products').slick({
    dots: true,
    infinite: true,
    speed: 300,
    lazyLoad: 'ondemand',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 410,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      }
    ]
  });
}
/*----------------------------------slick slider----------------------------------*/


/*----------------------------------slick slider----------------------------------*/
if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === "function" && jQuery("ol.flex-control-thumbs").length) {
  jQuery('ol.flex-control-thumbs').slick({
    dots: true,
    infinite: true,
    speed: 300,
    lazyLoad: 'ondemand',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 410,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      }
    ]
  });
}
/*----------------------------------slick slider----------------------------------*/
// giftscarousel initialized in theme.js — removed duplicate here
/*----------------------------------slick slider----------------------------------*/


/*woocommerce*/

jQuery(document).ready(function ($) {
  $pathName = document.location.pathname;
  $newCartUrl = $pathName.split('/').slice(0, -2).join('/') + '/cart';
  jQuery('.wpmc-tab-text a').attr('href', $newCartUrl);

  console.log($pathName);
  console.log($newCartUrl);
});

jQuery("li.wpmc-billing:first-child").before('<li class=""><div class="wpmc-tab-number">1</div><div class="wpmc-tab-text"><a href="">Cart</a></div></li>');

// jQuery(document).ready(function ($) {
//   jQuery('.cartclick,.mobilecartwrapper').on("click", function () {
//     console.log('test cart');
//     jQuery('.cartdropdown').slideToggle();
// /*----------------------------------slick slider----------------------------------*/
//   });
// });


// Product accordion toggle
jQuery(document).on('click', '.productaccordion h3[data-toggle="collapse"]', function() {
  var $this = jQuery(this);
  var target = $this.data('target');
  $this.toggleClass('active');
  jQuery(target).toggleClass('show');
});

/*---shop steps on mobile - add 1 to the numbers---*/
var checkDown = jQuery('.wpmc-billing .wpmc-tab-number').text();
jQuery('.wpmc-billing .wpmc-tab-number').text(+checkDown + 1);

var checkDown = jQuery('.wpmc-review .wpmc-tab-number').text();
jQuery('.wpmc-review .wpmc-tab-number').text(+checkDown + 1);

var checkDown = jQuery('.wpmc-payment .wpmc-tab-number').text();
jQuery('.wpmc-payment .wpmc-tab-number').text(+checkDown + 1);


/*gift card placeholder*/
jQuery("#ywgc-sender-name").attr("placeholder", "Your Name");


jQuery(document).ready(function ($) {
  jQuery('.product-quantity').off('click.wooQty', 'button.plus, button.minus')
    .on('click.wooQty', 'button.plus, button.minus', function () {

    // Get current quantity values
    var qty = jQuery(this).closest('.product-quantity').find('.qty');
    var val = parseFloat(qty.val());
    var max = parseFloat(qty.attr('max'));
    var min = parseFloat(qty.attr('min'));
    var step = parseFloat(qty.attr('step'));

    jQuery('.updatecartbtn').removeAttr("disabled");

    // Change the value if plus or minus
    if (jQuery(this).is('.plus')) {
      if (max && (max <= val)) {
        qty.val(max);
      } else {
        qty.val(val + step);
      }
    } else {
      if (min && (min >= val)) {
        qty.val(min);
      } else if (val > 1) {
        qty.val(val - step);
      }
    }

  });
});


/*filter*/

// JavaScript Document

var x, i, j, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("custom-select");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < selElmnt.length; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function (e) {
      /*when an item is clicked, update the original select box,
      and the selected item:*/
      var y, i, k, s, h;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      h = this.parentNode.previousSibling;
      for (i = 0; i < s.length; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          for (k = 0; k < y.length; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /*when the select box is clicked, close any other select boxes,
    and open/close the current select box:*/
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);

// change the donate placeholder
jQuery('.uk .wdgk_donation_content input[name="donation-price"]').attr('placeholder', 'EX.£5');
jQuery('.au .wdgk_donation_content input[name="donation-price"]').attr('placeholder', 'EX.$10');

// change the gift card title
jQuery('.gift-card-content-editor .ywgc-editor-section-title').text('e-gift details');

// remove categories filter
jQuery(".productcatsort:contains('Categories')").html(function (_, html) {
  return html.replace(/(Categories)/g, '<span class="d-none">Categories</span>')
});

//replace gift card button from select amount to read more
jQuery(".product_type_gift-card.add_to_cart_button").text('Read more');

// //show description content
// jQuery(".product-type-gift-card #procuctaccordioncontent1").addClass('show');
// //remove toggle
// jQuery(".product-type-gift-card .woocommerce-tabs.wc-tabs-wrapper h3").removeAttr('data-target');



//refresh page after cart upload
jQuery(document.body).on('updated_cart_totals', function () {
  location.reload();
});

// Checkout - country dropdown
// On page load if title is already set than user has already selected a country in dropdown
jQuery(document).ready(function () {
  if (jQuery("#select2-billing_country-container").text() === "Select a country / region…" &&
    jQuery("#select2-billing_country-container").prop('title')
  ) {
    jQuery("#select2-billing_country-container").text(jQuery("#select2-billing_country-container").prop('title'));
  }
  if (jQuery(".ywgc-empty-recipient-note").length) {
    //rewrite message

    jQuery(".ywgc-empty-recipient-note").text(`If the recipient's details are left blank, the e-card will be sent to your email address`);

    // Disable the quantity field
    jQuery('.gift_card_template_button .quantity .qty').prop('disabled', true).css('background-color', 'lightgray');
  }


});

// SPNR-43 - Donation rounding suggestion at shop checkout
// On the basket checkout page dynamically calculate the donation amount to make the subtotal a multiple of 5
jQuery(document).ready(function ($) {
  const ELEMENTS = {
    CART_FORM: 'woocommerce-cart-form',
    SUBTOTAL_CONTAINER: 'cart-subtotal',
    SUBTOTAL_AMOUNT: 'woocommerce-Price-amount',
    DONATION_INPUT: 'wdgk_donation'
  };

  // Check we are on the checkout page and there is no donation in the basket
  if (jQuery(`.${ELEMENTS.CART_FORM}`).length > 0 && jQuery(`.${ELEMENTS.DONATION_INPUT}`).val() === '') {
    calculateDonationAmount(ELEMENTS);
  }
});

/**
 * Populate the donation input with a calculated amount based on the subtotal of the customers basket,
 * rounded up to the nearest multiple of 5
 * @param ELEMENTS
 */
function calculateDonationAmount(ELEMENTS) {
  const $subtotalElement = jQuery(`.${ELEMENTS.SUBTOTAL_CONTAINER} .${ELEMENTS.SUBTOTAL_AMOUNT}`).text();

  // Check if sub total element exists
  if ($subtotalElement) {
    // Remove currency symbol
    const subtotal = $subtotalElement.slice(1);

    // Check if the subtotal is not divisible by 5
    if (subtotal % 5 !== 0) {
      // Round up to the nearest multiple of 5
      const roundedTotal = Math.ceil(subtotal / 5) * 5;

      // Calculate donation amount
      const donationAmount = (roundedTotal - subtotal).toFixed(2);

      // Dynamically change donation amount
      jQuery(`.${ELEMENTS.DONATION_INPUT}`).val(donationAmount);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
    // Select the specific IDs
    const selectors = ['#your_detalis_field', '#address_details_field'];
    
    selectors.forEach(selector => {
        const element = document.querySelector(selector);

        // Check if the element actually exists in the DOM
        if (element) {
            let text = element.innerText.trim();

            if (text.length > 0) {
                // Apply Sentence case logic
                element.innerText = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            }
        }
    });
});